import React from 'react';
import {createRoot} from 'react-dom/client';
import ActionButton from '../buttons/action-button';
import Modal from './modal';

const YesNoModal = ({yesAction, noAction, errorHandler, children}) => {

  let actionTriggered = false;

  const triggerAction = action => {
    actionTriggered = true;
    return action();
  };

  const footer = closeModalFn => {
    return <>
      <ActionButton className="btn-sm btn-secondary px-5"
                    action={() => triggerAction(() => noAction(closeModalFn))}
                    errorHandler={errorHandler}>
        No
      </ActionButton>
      <ActionButton className="btn-sm btn-primary px-5"
                    action={() => triggerAction(() => yesAction(closeModalFn))}
                    errorHandler={errorHandler}>
        Yes
      </ActionButton>
    </>
  };

  return <Modal footer={closeFn => footer(closeFn)}
                onClose={() => {
                  if (!actionTriggered) {
                    triggerAction(() => noAction(() => {}));
                  }
                }}>
    {children}
  </Modal>;
};

export default YesNoModal;

const displayYesNoModal = (body, errorHandler) => {
  return new Promise(resolve => {
    const modalContainer = document.createElement('div');
    window.document.body.appendChild(modalContainer);
    const action = (result, closeModalFn) => {
      closeModalFn();
      resolve(result);
      return Promise.resolve();
    };
    createRoot(modalContainer).render(
      <YesNoModal yesAction={closeModalFn => action(true, closeModalFn)}
                  noAction={closeModalFn => action(false, closeModalFn)}
                  errorHandler={errorHandler}>
        {body}
      </YesNoModal>
    );
  });
};

export {displayYesNoModal};
